var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('section',{},[_c('div',{staticClass:" max-w-screen-lg  pt-0 md:pt-0 mx-auto min-h-screen px-2 sm:px-8"},[_c('router-view',{staticClass:"mt-4"})],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }